<!-- filepath: c:\Users\gabri\Documents\GitHub\medexperts\src\components\CSATDialog.vue -->
<template>
  <v-dialog v-model="internalDialog" max-width="90%" persistent>
    <v-card class="elevated-card">
      <v-card-title class="headline text-center">
        Pesquisa de Satisfação
      </v-card-title>
      <v-card-text>
        <div class="text-center">
          <p class="mb-6 description">
            Sua opinião é muito importante para nós! Como você avalia a sua experiência com o nosso aplicativo?
          </p>
          <div class="rating-buttons">
            <v-btn
              v-for="rating in [1, 2, 3, 4, 5]"
              :key="rating"
              :color="csatRating === rating ? 'primary' : 'grey lighten-2'"
              class="rating-btn"
              @click="csatRating = rating"
            >
              {{ rating }}
            </v-btn>
          </div>
          <div v-if="csatRating" class="rating-feedback mt-6">
            <p class="emoji">{{ getEmoji(csatRating) }}</p>
            <p class="feedback-text">{{ getRatingMessage(csatRating) }}</p>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          color="primary"
          :disabled="!csatRating"
          class="elevated-btn"
          @click="submitCSAT"
        >
          Enviar Avaliação
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showCSATDialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      internalDialog: this.showCSATDialog, // Sincroniza com a prop
      csatRating: null, // Armazena a nota de 1 a 5
    };
  },
  watch: {
    // Atualiza o estado interno quando a prop mudar
    showCSATDialog(newValue) {
      this.internalDialog = newValue;
    },
    // Emite o evento de atualização quando o estado interno mudar
    internalDialog(newValue) {
      this.$emit("update:showCSATDialog", newValue);
    },
  },
  methods: {
    submitCSAT() {
      // Envia a nota para o servidor ou realiza outra ação
      console.log("CSAT Rating:", this.csatRating);

      // Fecha o diálogo e emite o evento de fechamento com o rating
      this.$emit("close", this.csatRating);
      this.internalDialog = false;
    },
    getRatingMessage(rating) {
      const messages = {
        1: "Muito insatisfeito 😞",
        2: "Insatisfeito 🙁",
        3: "Neutro 😐",
        4: "Satisfeito 🙂",
        5: "Muito satisfeito 😄",
      };
      return messages[rating] || "";
    },
    getEmoji(rating) {
      const emojis = {
        1: "😞",
        2: "🙁",
        3: "😐",
        4: "🙂",
        5: "😄",
      };
      return emojis[rating] || "";
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}

.description {
  font-size: 1.4rem;
  color: #424242;
  line-height: 1.8;
}

.rating-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap; /* Permite que os botões quebrem linha em telas menores */
}

.rating-btn {
  width: 80px;
  height: 80px;
  border-radius: 12px; /* Botões mais quadrados e modernos */
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.rating-btn:hover {
  transform: scale(1.1);
}

.rating-feedback {
  margin-top: 30px;
  text-align: center;
}

.emoji {
  font-size: 3rem;
  margin-bottom: 10px;
}

.feedback-text {
  font-size: 1.4rem;
  font-weight: bold;
  color: #424242;
}

.elevated-btn {
  font-weight: bold;
  text-transform: uppercase;
  padding: 12px 24px;
  border-radius: 8px;
}

.elevated-card {
  border-radius: 16px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  padding: 40px; /* Aumenta o espaçamento interno do card */
}

.v-card-title {
  font-size: 2rem;
  font-weight: bold;
  color: #424242;
  text-align: center;
  margin-bottom: 20px; /* Espaçamento abaixo do título */
}

.v-card-text {
  padding: 20px 40px; /* Aumenta o espaçamento interno do texto */
}

.v-card-text p {
  font-size: 1.2rem;
  color: #616161;
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .elevated-card {
    padding: 20px; /* Reduz o espaçamento interno em telas menores */
  }

  .rating-btn {
    width: 60px;
    height: 60px;
    font-size: 1.2rem; /* Reduz o tamanho dos botões */
  }

  .emoji {
    font-size: 2.5rem; /* Reduz o tamanho do emoji */
  }

  .feedback-text {
    font-size: 1.2rem; /* Reduz o tamanho do texto de feedback */
  }

  .v-card-title {
    font-size: 1.5rem; /* Reduz o tamanho do título */
  }

  .description {
    font-size: 1.2rem; /* Reduz o tamanho da descrição */
  }
}
</style>